/* unplugin-vue-components disabled */import { render } from "./UserDesc.vue?vue&type=template&id=6601989c&scoped=true"
import script from "./UserDesc.vue?vue&type=script&lang=js"
export * from "./UserDesc.vue?vue&type=script&lang=js"

import "./UserDesc.vue?vue&type=style&index=0&id=6601989c&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/zeta-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6601989c"]])

export default __exports__